import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var DistributionRequests =
/*#__PURE__*/
function (_BaseData) {
  _inherits(DistributionRequests, _BaseData);

  function DistributionRequests() {
    _classCallCheck(this, DistributionRequests);

    return _possibleConstructorReturn(this, _getPrototypeOf(DistributionRequests).call(this, "DistributionRequests"));
  }

  _createClass(DistributionRequests, [{
    key: "GetPropertyHistory",
    value: function () {
      var _GetPropertyHistory = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(propertyId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetPropertyHistory/").concat(propertyId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetPropertyHistory(_x) {
        return _GetPropertyHistory.apply(this, arguments);
      }

      return GetPropertyHistory;
    }()
  }, {
    key: "CreateByAfsId",
    value: function () {
      var _CreateByAfsId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(afsId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/CreateByAfsId/").concat(afsId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function CreateByAfsId(_x2) {
        return _CreateByAfsId.apply(this, arguments);
      }

      return CreateByAfsId;
    }()
  }, {
    key: "GetReviewListByYear",
    value: function () {
      var _GetReviewListByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(year) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetReviewListByYear/").concat(year)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetReviewListByYear(_x3) {
        return _GetReviewListByYear.apply(this, arguments);
      }

      return GetReviewListByYear;
    }()
  }, {
    key: "StartReview",
    value: function () {
      var _StartReview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(id) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.put("/api/".concat(this._controller, "/StartReview/").concat(id)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function StartReview(_x4) {
        return _StartReview.apply(this, arguments);
      }

      return StartReview;
    }()
  }, {
    key: "Approve",
    value: function () {
      var _Approve = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(id) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.put("/api/".concat(this._controller, "/Approve/").concat(id)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function Approve(_x5) {
        return _Approve.apply(this, arguments);
      }

      return Approve;
    }()
  }, {
    key: "Deny",
    value: function () {
      var _Deny = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(id) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.put("/api/".concat(this._controller, "/Deny/").concat(id)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function Deny(_x6) {
        return _Deny.apply(this, arguments);
      }

      return Deny;
    }()
  }, {
    key: "Reopen",
    value: function () {
      var _Reopen = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(id) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.put("/api/".concat(this._controller, "/Reopen/").concat(id)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function Reopen(_x7) {
        return _Reopen.apply(this, arguments);
      }

      return Reopen;
    }()
  }, {
    key: "AdminChangeStatus",
    value: function () {
      var _AdminChangeStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(HeaderId, StatusId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.get("api/".concat(this._controller, "/AdminChangeStatus/").concat(HeaderId, "/").concat(StatusId)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function AdminChangeStatus(_x8, _x9) {
        return _AdminChangeStatus.apply(this, arguments);
      }

      return AdminChangeStatus;
    }()
  }, {
    key: "GetMultiNavList",
    value: function () {
      var _GetMultiNavList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("api/".concat(this._controller, "/GetMultiNavList")));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function GetMultiNavList() {
        return _GetMultiNavList.apply(this, arguments);
      }

      return GetMultiNavList;
    }()
  }]);

  return DistributionRequests;
}(BaseData);

export default new DistributionRequests();